export enum CashbackLoyaltyFormInput {
    LIMIT = 'limit',
    POINTS_PER_EURO = 'cashBackPointsPerEuro',
    MIN_BASKET = 'minBasket'
}

export const cashbackLoyaltyFormError = 'is-invalid';
export const cashbackLoyaltyFormValid = 'is-valid';
export const invalidCashbackRatioMessage = "Le gain de fidélité est trop faible par rapport au montant dépensé. Pour corriger cela, augmentez le montant de fidélité ou diminuez le montant requis.";
export const cashbackPointConversionMaxDecimal = 6;
export const invalidMaxDecimalMessage = (max: number) => `Veuillez saisir un nombre avec ${max} décimales maximum.`